<div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-27">
  <div class="mct-flex-1-1-0">
    <label class="light-text">{{ 'tasks.search.assigned-by-or-assigned-to' | translate }}</label>
    <p-select
      placeholder="{{ 'tasks.search.all' | translate | uppercase }}"
      appendTo="body"
      [(ngModel)]="searchParams.AssignedByOrToUserNum"
      [options]="assignedToUserItems"
      [style]="{ width: '100%', height: '36px' }"
      showClear
    ></p-select>
  </div>
  <div class="mct-flex mct-col mct-flex-1-1-0">
    <label class="light-text">{{ 'tasks.search.keywords-in-the-title-or-note' | translate | ucfirst }}</label>
    <input [(ngModel)]="searchParams.TitleOrNoteKeywords" />
  </div>
  <div class="task-search-400px">
    <label class="light-text">{{ 'tasks.search.due-date' | translate | ucfirst }}</label>
    <div class="mct-flex mct-row mct-justify-center mct-items-center mct-gap-11">
      <wl-date-selector [(ngModel)]="searchParams.DueDateRangeStart"></wl-date-selector>
      <span class="light-text">{{ 'tasks.search.through' | translate }}</span>
      <wl-date-selector [(ngModel)]="searchParams.DueDateRangeEnd"></wl-date-selector>
    </div>
  </div>
  <div>
    <label class="light-text">{{ 'tasks.search.completed-or-not-completed' | translate | ucfirst }}</label>
    <div class="mct-flex mct-row mct-justify-center mct-items-center mct-gap-20">
      <p-radioButton name="completedSearch" inputId="both" [(ngModel)]="searchParams.Complete" [value]="null"> </p-radioButton>
      <label for="both">
        {{ 'tasks.search.both' | translate | ucfirst }}
      </label>
      <p-radioButton name="completedSearch" inputId="completed" [(ngModel)]="searchParams.Complete" [value]="true"> </p-radioButton>
      <label for="completed">
        {{ 'tasks.search.completed' | translate | ucfirst }}
      </label>
      <p-radioButton name="completedSearch" inputId="notCompleted" [(ngModel)]="searchParams.Complete" [value]="false"> </p-radioButton>
      <label for="notCompleted">
        {{ 'tasks.search.not-completed' | translate | ucfirst }}
      </label>
    </div>
  </div>
</div>
